/*
  Monsor — stabiele sluit-cursor (X) over de drawer-overlay.

  Het thema zet de class 'active' op <mouse-cursor> via mousemove/mouseleave
  op de overlay zelf. Zodra de muis over een element beweegt dat de overlay
  onderbreekt (header, doorschemerende pagina-inhoud), vuurt mouseleave en
  verdwijnt de X, ook al zit je nog buiten het paneel.

  Dit script stuurt de X op basis van: is er een drawer actief en zit de muis
  buiten het paneel (.drawer__inner)? Zo ja -> X tonen. Binnen het paneel -> uit.
  Werkt op document-niveau, dus onafhankelijk van waar de muis precies overheen gaat.
*/
(function () {
  if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function onMove(event) {
    var cursor = document.querySelector('mouse-cursor');
    if (!cursor) return;

    var drawer = document.querySelector('.drawer[active]');
    if (!drawer) return;

    var target = event.target;
    var overPanel = !!(target && target.closest && target.closest('.drawer__inner'));

    cursor.classList.toggle('active', !overPanel);
    cursor.setAttribute('aria-hidden', overPanel ? 'true' : 'false');
  }

  document.addEventListener('mousemove', onMove, { passive: true });
})();